var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toll-modal"},[_c('h3',{staticClass:"map-modal__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"map-modal__content"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }